import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

@Injectable()
export class ExternalLinkResolver {
  constructor(private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const externalUrl = route.paramMap.get('externalUrl');
    let target = route.paramMap.get('target');
    if (!target) {
      target = '_blank';
    }
    window.open(externalUrl, target);
    this.router.navigateByUrl(location.pathname);
  }
}
